import { render, staticRenderFns } from "./handwriting.vue?vue&type=template&id=97ea43ca&scoped=true&"
import script from "./handwriting.vue?vue&type=script&lang=js&"
export * from "./handwriting.vue?vue&type=script&lang=js&"
import style0 from "./handwriting.vue?vue&type=style&index=0&id=97ea43ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ea43ca",
  null
  
)

export default component.exports